import { FilterOption } from 'interfaces/components/filter';

export const yourCompanyColor = '#5656B1';
export const topQuartileColor = '#4DB96B';
export const medianColor = '#70A7B2';
export const labelTopQuartile = 'Compass Software Benchmark Top Quartile';
export const labelMedian = 'Compass Software Benchmark Median';
export const labelYourCompany = "Your Company's Data";
export const labelAverage = 'Compass Software Benchmark Average';

export const CHARTS_TITLES = [
  'YoY ARR Growth',
  'Gross New ARR Composition',
  'New Logo Velocity',
  'Quick Ratio',
  'Gross Dollar Retention',
  'Net Dollar Retention',
  'Net Magic Number',
  'Rule of 40',
  'CAC Payback',
  'Burn Multiple',
  'OpEx as a % of Revenue',
  'Gross Margin',
  'FCF Margin',
  'Headcount Distribution',
  'ARR per FTE',
  'OpEx per FTE'
];

export const softwareSectorFilterOptions: FilterOption[] = [
  { label: 'Infrastructure & Security', value: 'Infrastructure' },
  { label: 'Vertical application', value: 'Vertical SaaS' },
  { label: 'Horizontal application', value: 'Horizontal SaaS' }
  // { label: 'B2B Fintech', value: 'Fintech' },
  // { label: 'HCIT', value: '"Healthcare"' }
];

export const growthMotionFilterOptions: FilterOption[] = [
  { label: 'Product-Led Growth', value: 'Product-led Growth' },
  { label: 'Sales-Led Growth', value: 'Sales-led Growth' }
];

export const primaryCustomerFilterOptions: FilterOption[] = [
  { label: 'SMB to Mid-Market', value: 'SMB to Mid-Market' },
  { label: 'Mid-Market to Enterprise', value: 'Mid-Market to Enterprise' }
];

export enum modalSections {
  REQUIRED_INFORMATION = 'required_information',
  GROWTH_AND_RETENTION = 'growth_and_retention',
  OPERATIONAL_EFFICIENCY = 'operational_efficiency',
  HEADCOUNT = 'headcount',
  COMPANY_DETAILS = 'company_details'
}

export const modalSectionsConfig = [
  {
    id: modalSections.REQUIRED_INFORMATION,
    label: 'Required Information'
  },
  {
    id: modalSections.GROWTH_AND_RETENTION,
    label: 'Growth and Retention'
  },
  {
    id: modalSections.OPERATIONAL_EFFICIENCY,
    label: 'Operational Efficiency'
  },
  {
    id: modalSections.HEADCOUNT,
    label: 'Headcount'
  },
  {
    id: modalSections.COMPANY_DETAILS,
    label: 'Company Details'
  }
];

export enum companyStatus {
  PUBLIC = 'public',
  PRIVATE = 'private'
}

export enum modalModes {
  ADD = 'add',
  EDIT = 'edit'
}

export enum urlParamNames {
  COMPANY_STATUS = 'status',
  CURRENT_ARR = 'arr_or_revenue',
  YOY_ARR = 'yoy_arr_or_growth',
  FCF_MARGIN = 'fcf_margin',
  AVG_DEAL_SIZE = 'avg_deal_size',
  TOTAL_HEADCOUNT = 'headcount',
  COMPANY_WEBSITE = 'website',
  GROSS_MARGIN = 'gross_margin',
  NET_DOLLAR_RETENTION = 'net_dollor_retention',
  NET_MAGIC_NUMBER = 'magic_number',
  BURN_MULTIPLE = 'burn_multiple',
  QUICK_RATIO = 'quick_ratio',
  BRAND_COLOR = 'brand_color',
  RD = 'opex_rd',
  GA = 'opex_ga',
  SM = 'opex_sm',
  RD_HEAD = 'headcount_rd',
  GA_HEAD = 'headcount_ga',
  SM_HEAD = 'headcount_sm',
  EMAIL = 'email',
  REVENUE = 'revenue',
  ARR_PER_FTE = 'arr_per_fte',
  RULE_OF_40 = 'rule_of_40',
  NEW_LOGO_ARR_OF_GROSS_NEW = 'new_logo_arr_of_gross_new',
  EXPANSION_ARR_OF_GROSS_NEW = 'expansion_arr_of_gross_new',
  GROSS_DOLLAR_RETENTION = 'gross_dollar_retention',
  NEW_LOGO_VELOCITY = 'new_logo_velocity',
  CAC_PAYBACK_PERIOD = 'cac_payback_period',
  OPEX_PER_FTE = 'opex_per_fte',
  RD_PERCENT = 'rd_percent',
  GA_PERCENT = 'ga_percent',
  SM_PERCENT = 'sm_percent',
  RD_HEAD_PERCENT = 'rd_head_percent',
  GA_HEAD_PERCENT = 'ga_head_percent',
  SM_HEAD_PERCENT = 'sm_head_percent',
  TOTAL_OPEX = 'total_opex'
}

export const fileTypes = ['image/png', 'image/jpeg', 'image/jpg'];

export enum modalTabs {
  SAVED_USER_DATA = 'Saved User Data',
  FORM = 'Form'
}
